module.exports = __webpack_public_path__ + "static/media/icon_instrument_default.490bf383.svg";